import { ICommand } from './ICommand';
import { getNodeMutationManager } from './mutations/NodeMutationManager';
import type { TableCellKey } from '../../stores/tableCellStore';

type Params = {
  nodeId: string;
  cellKeys: TableCellKey[];
};

export class ClearTableCellTextsCommand implements ICommand {
  id = `clear-table-cell-texts-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  name = 'Clear Table Cell Texts';
  timestamp = Date.now();

  private previousByKey: Record<string, string | undefined> = {};

  constructor(private params: Params) {}

  async execute(): Promise<void> {
    const mm = getNodeMutationManager();
    const node = mm.getNode(this.params.nodeId);
    if (!node) return;
    const attrs = (node.attrs ?? {}) as Record<string, unknown>;
    const prevMap = (attrs.cellText as Record<string, string> | undefined) ?? {};
    const nextMap: Record<string, string> = { ...prevMap };

    const uniq = Array.from(new Set(this.params.cellKeys));
    uniq.forEach((k) => {
      this.previousByKey[k] = prevMap[k];
      delete nextMap[k];
    });

    mm.applyNodeChange(this.params.nodeId, { attrs: { cellText: nextMap } } as any);
  }

  async undo(): Promise<void> {
    const mm = getNodeMutationManager();
    const node = mm.getNode(this.params.nodeId);
    if (!node) return;
    const attrs = (node.attrs ?? {}) as Record<string, unknown>;
    const prevMap = (attrs.cellText as Record<string, string> | undefined) ?? {};
    const nextMap: Record<string, string> = { ...prevMap };

    Object.entries(this.previousByKey).forEach(([k, v]) => {
      if (typeof v === 'string') nextMap[k] = v;
      else delete nextMap[k];
    });

    mm.applyNodeChange(this.params.nodeId, { attrs: { cellText: nextMap } } as any);
  }

  async redo(): Promise<void> {
    await this.execute();
  }

  getMetadata(): Record<string, unknown> {
    return {
      nodeId: this.params.nodeId,
      cellKeys: this.params.cellKeys,
    };
  }
}

